import * as angular from 'angular'

angular
  .module('exceptionOverride', [])
  .factory('$exceptionHandler', function ($log, $window) {
    'ngInject'
    return function (exception, cause) {
      exception.message += ' (caused by "' + cause + '")'
      $log.error.apply($log, arguments)
    }
  })
